import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import SenseTour from "components/Tour/SenseTour";

import { getIsOpenSense, getStep, updateIsOpenSense, updateStep } from "containers/Tour/reducer";
import { updateType } from "containers/View/reducer";
import * as viewReducer from "containers/View/reducer";

class SenseTourContainer extends React.PureComponent {
  render() {
    return <SenseTour {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateIsOpenSense: (isOpen) => dispatch(updateIsOpenSense(isOpen)),
    updateStep: (step) => dispatch(updateStep(step)),
    updateType: (type) => dispatch(updateType(type))
  };
};

const mapStateToProps = (state, ownProps) => {
  const isOpen = getIsOpenSense(state);

  return {
    isOpen: isOpen,
    step: getStep(state),
    dataset: isOpen ? viewReducer.getFirstDataset(state) : {}
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(SenseTourContainer);
